import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/modal/Modal/Modal'
import { useMedia } from 'sb-hooks'
import { constants } from 'common/helpers'

import Text from 'components/_new/typography/Text/Text'
import { Button } from 'components/_new/controls'
import { Box } from 'components/_new/layout'

import useRefund from 'components/modals/cancelSubscription/util/useRefund'

import messages from './messages'


const RefundOnTheDayOfCharge = (props) => {
  const { name, data: { type, transactionType, onClose } } = props
  const { isMobile } = useMedia()

  const { chooseReceive, chooseRefund } = useRefund(name, type, transactionType)

  const onReceive = useCallback(() => {
    chooseReceive()
      .finally(onClose)
  }, [ chooseReceive, onClose ])

  const onRefund = useCallback(() => {
    chooseRefund()
      .finally(onClose)
  }, [ chooseRefund, onClose ])

  return (
    <Modal
      name={name}
      title={messages.title}
      onClose={onReceive}
    >
      <Text message={messages.text} html size={isMobile ? '20-24' : '16-24'} />
      <Box mt={20}>
        <Button
          title={messages.buttons.refund}
          size={isMobile ? 'sm' : 'md'}
          onClick={onRefund}
          dataTestId={constants.testIds.cancelSubscription.refundButton}
          fullWidthOnMobile
        />
        <Button
          title={messages.buttons.receive}
          size={isMobile ? 'sm' : 'md'}
          onClick={onReceive}
          color="brand"
          dataTestId={constants.testIds.cancelSubscription.receiveButton}
          fullWidthOnMobile
        />
      </Box>
    </Modal>
  )
}

RefundOnTheDayOfCharge.propTypes = {
  name: PropTypes.string.isRequired,
  data: PropTypes.shape({
    type: PropTypes.string,
    status: PropTypes.string,
    transactionType: PropTypes.oneOf([ 'PAUSE', 'SKIP', 'UNSUBSCRIBE' ]),
    onClose: PropTypes.func.isRequired,
  }),
}

RefundOnTheDayOfCharge.defaultProps = {
  name: constants.modals.cancelSubscription.RefundOnTheDayOfCharge,
}


export default RefundOnTheDayOfCharge
